import BaseClient from './BaseClient';
import axios from '~/services/axios';

class AdminUsersClient extends BaseClient {
    showUser(userId) {
        const url = `/api/admin/users/${userId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    listUserTeams(userId, params) {
        const url = `/api/admin/users/${userId}/teams`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    listUserLogins(userId, params) {
        const url = `/api/admin/users/${userId}/logins`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    listUsers(params) {
        const url = `/api/admin/users`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    favoriteUser(userId) {
        const url = `/api/admin/users/${userId}/favorite`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteFavoriteUser(userId) {
        const url = `/api/admin/users/${userId}/favorite`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    suspendUser(userId, data) {
        const url = `/api/admin/users/${userId}/suspend`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    unsuspendUser(userId) {
        const url = `/api/admin/users/${userId}/unsuspend`;
        return this.makeCoreApiRequest(url, 'post');
    }

    /**
     * Returns a pre-signed S3 URL to upload a CSV file with coupons.
     *
     * @param teamId
     * @param fileName This name will be displayed to the used
     * @returns {Promise<AxiosResponse<any>>}
     */
    generateImportPresignedUrl(teamId, fileName) {
        const method = 'post';
        const url = `/api/admin/teams/${teamId}/users/upload-urls`;

        return this.makeCoreApiRequest(url, method, {
            original_file_name: fileName,
        });
    }

    /**
     * Uploads a CSV file with coupons to be imported.
     *
     * @param preSignedS3Url
     * @param file
     * @returns {Promise<AxiosResponse<any>>}
     */
    importCsvFileToS3(preSignedS3Url, file) {
        return axios.put(preSignedS3Url, file, {
            headers: {
                'Content-Type': 'text/csv',
            },
        });
    }
}

export default new AdminUsersClient();
